import React from "react";
import { Helmet } from "react-helmet";
import styles from "../style.module.scss";
import { PageBanner } from "../../../../components/parts/section";
import { productData } from "../../../../utils/constants";
import { CommonProductPage } from "../../../../components/parts";

const HotGalvanizedSteel = () => {
  const singleProductData = productData.filter((val) => val.id === 9);
  return (
    <>
      <Helmet>
        <title>
          Hot Dipped Galvanized Steel Pipe | Hot Rolled Galvanized Steel Sheet
        </title>
        <meta
          name="description"
          content="Hot rolled Galvanized steel sheet manufactured by APF Steel is a leading supplier for your project requirements."
        />
      </Helmet>
      <div className={styles.productInnerPage}>
        <PageBanner image={singleProductData[0].featured_image} />
        <CommonProductPage
          title={singleProductData[0].name}
          description={singleProductData[0].description}
          features={singleProductData[0].product_feature}
          gallery={singleProductData[0].productGallery}
        />
      </div>
    </>
  );
};

export default HotGalvanizedSteel;
